import { setFaultLevels } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { FaultLevel } from '@customer/store/slices/globalSlice';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';

const useFaultLevelOptions = (): DropdownItemProps<FaultLevel>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return Object.values(FaultLevel).map((value: FaultLevel) => {
      return {
        key: value,
        value,
        stringValue: value,
        label: t('FaultsLevel', { level: value }),
      };
    });
  }, [t]);
};

export const FaultLevelsFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<FaultLevel>
      filterName="faultLevels"
      label={label ?? t('FaultLevel')}
      action={setFaultLevels}
      elementRef={elementRef}
      useItemsHook={useFaultLevelOptions}
    />
  );
};

export default FaultLevelsFilter;
